export default class VariantCharacter {
  constructor (data = {}) {
    Object.keys(data).map(key => {
      this[key] = data[key];
    });
  }
  static fromJson (json) {
    return new VariantCharacter(json);
  }
}
